'use strict';

/**
 * Fixture activity rows for the `/home/pipeline-tracker` ticker preview.
 * Stamps snapshot facts into the last six hours so the live age filter keeps them.
 */

import { getMockPipelineStatusSnapshotForScenario } from './mocks/pipelineStatusFacts.mock';
import { composeMockPipelineStatusCatalog } from './mocks/composeMockPipelineStatusGraph';
import { processActivityStripRows } from '@/components/layout/activityStripUtils';

const FALLBACK_FACTS = Object.freeze([
	{
		subjectType: 'Project',
		subjectId: 'DEMO',
		pipeline: 'V7',
		service: 'PortalApi',
		stage: 'V7ProjectAvailable',
		status: 'Started',
		detailsJson: JSON.stringify({ projectCode: 'DEMO' }),
	},
	{
		subjectType: 'SampleSet',
		subjectId: 'SS-1',
		pipeline: 'Core',
		service: 'PortalApi',
		stage: 'ProductSampleSetAvailable',
		status: 'Completed',
		detailsJson: JSON.stringify({ projectCode: 'DEMO', sampleSetName: 'Plasma' }),
	},
	{
		subjectType: 'SampleSet',
		subjectId: 'SS-2',
		pipeline: 'Core',
		service: 'PortalApi',
		stage: 'ProductSampleSetAvailable',
		status: 'Failed',
		detailsJson: JSON.stringify({ projectCode: 'DEMO', sampleSetName: 'Serum' }),
	},
]);

/**
 * @param {import('./pipelineStatusShowcaseCatalog').ShowcaseScenario | undefined} scenario
 * @param {number} [nowMs]
 */
export function buildShowcaseActivityRows(scenario, nowMs = Date.now()) {
	let facts = [];
	if (scenario?.mockScenarioKey) {
		try {
			facts = getMockPipelineStatusSnapshotForScenario(scenario.mockScenarioKey).facts ?? [];
		} catch {
			facts = [];
		}
	}
	if (!facts.length) {
		facts = [...FALLBACK_FACTS];
	}

	const stamped = facts.map((row, i) => ({
		...row,
		occurredAt: new Date(nowMs - (i % 50) * 60 * 1000).toISOString(),
	}));
	return processActivityStripRows(stamped, composeMockPipelineStatusCatalog(), undefined, nowMs);
}
